import React from 'react';
import { Modal, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const DeletePDFModal = ({ show, onClose, onDelete, pdfTitle }) => {
  return (
    <Modal
      title={
        <div>
          <ExclamationCircleOutlined style={{ color: '#ff4d4f', marginRight: 8 }} />
          Delete PDF Resource
        </div>
      }
      visible={show}
      onCancel={onClose}
      onOk={onDelete}
      okText="Delete"
      cancelText="Cancel"
      okButtonProps={{ danger: true }}
    >
      <div>
        <p>Are you sure you want to delete this PDF resource?</p>
        <p>
          <Text strong>{pdfTitle}</Text>
        </p>
        <p style={{ color: '#ff4d4f' }}>
          This action cannot be undone. The PDF file will be permanently removed.
        </p>
      </div>
    </Modal>
  );
};

export default DeletePDFModal; 